module.exports = __webpack_public_path__ + "images/quick-massage.jpg?b946a8445fd46e5226f06ea9d4721f58";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/quick-massage.jpg
// module id = 988
// module chunks = 0